module.exports = __webpack_public_path__ + "static/img/img-remind.6fa7d7b4.png";